import ecommerceComponents from '@blaze-cms/plugin-ecommerce-components';
import ecommerceStripe from '@blaze-cms/plugin-ecommerce-stripe-fe';
import authFe from '@blaze-cms/plugin-auth-fe';
import authLocal from '@blaze-cms/plugin-auth-local-fe';
import examplePlugin from './blaze-plugins/example';
import ecommerceKpComponents from './blaze-plugins/blaze-plugin-ecommerce-kp-components/src';
import shopwareKp from './blaze-plugins/shopware-fe-kp';
import ecommeceEventsKp from './blaze-plugins/ecommerce-events-kp';
import contactForm from './blaze-plugins/kp-content';
import accessCode from './blaze-plugins/access-code';
import ebooks from './blaze-plugins/ebooks';

export default function buildConfig(config) {
  // To set custom plugins into the project.
  config.plugins.set(examplePlugin, {});
  config.plugins.set(ecommerceComponents, {});
  config.plugins.set(ecommerceKpComponents, {});
  config.plugins.set(shopwareKp, {});
  config.plugins.set(ecommerceStripe, {});
  config.plugins.set(ecommeceEventsKp, {});
  config.plugins.set(authLocal, {});
  config.plugins.set(contactForm, {});
  config.plugins.set(accessCode, {});
  config.plugins.set(ebooks, {});
  config.plugins.set(authFe, { authProviderOrder: ['blaze_shopware'] });

  // eslint-disable-next-line no-param-reassign
  config.apollo = {
    ...config.apollo,
    disableUpload: true
  };
  return config;
}
